export default __webpack_public_path__ + "static/media/no-farm.38a19c3a.svg";